import uniq from 'lodash-es/uniq'

import { CalendarGridItemVariant } from '../../../../../constants/calendarGrid'
import { CALENDAR_GRID_MINUTES_PER_ROW } from '../../../CalendarGrid.constants'
import { getCalendarGridTimeRangeLabel } from '../../../CalendarGrid.utils'
import { getCalendarGridGroupStyle } from '../../CalendarGridWeek.utils'

function getCalendarGridGroupVariant(items) {
  const variants = uniq(items.map(item => item.variant))

  return (
    variants.find(variant => variant !== CalendarGridItemVariant.muted) ??
    variants[0]
  )
}

function getIsCalendarGridGroupDisabled(items) {
  return items.every(item => item.isDisabled)
}

function getIsCalendarGridGroupCompact({ endOffset, startOffset }) {
  return endOffset - startOffset < CALENDAR_GRID_MINUTES_PER_ROW
}

export function getCalendarGridWeekBlockProps({ group, locale, timezone }) {
  const [item] = group.items

  return {
    isCompact: getIsCalendarGridGroupCompact(group),
    isDisabled: getIsCalendarGridGroupDisabled(group.items),
    isSecondaryLabelPinned: item.isSecondaryLabelPinned,
    style: getCalendarGridGroupStyle(group),
    timeLabel: getCalendarGridTimeRangeLabel({
      end: group.end,
      locale,
      start: group.start,
      timezone,
    }),
    variant: getCalendarGridGroupVariant(group.items),
  }
}
